module.exports = typeof function foo() {}.name === 'string'; // when function names are minified, checking for "foo" would break



//////////////////
// WEBPACK FOOTER
// ./~/function.prototype.name/helpers/functionsHaveNames.js
// module id = 481
// module chunks = 0